import script from "./NotificationGroup.vue?vue&type=script&lang=js"
export * from "./NotificationGroup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__